// import Satisfies from './Satisfies.js'
// import NotCondition from './NotCondition.js'
// import NotSatisfies from './NotEvaluator.js'
// import TimeCondition from './TimeCondition.js'
// import TimeSatisfies from './TimeEvaluator.js'
// import DeltaCondition from './DeltaCondition.js'
// import DeltaSatisfies from './DeltaEvaluator.js'
import LogicCondition from './logic/LogicCondition.js'
import LogicEvaluator from './logic/LogicEvaluator.js'
import AsyncLogicEvaluator from './logic/AsyncLogicEvaluator.js'
import PropertyCondition from './property/PropertyCondition.js'
import PropertyEvaluator from './property/PropertyEvaluator.js'

import TargetPreprocessor from './expression/TargetPreprocessor.js'

import ExpressionCondition from './expression/ExpressionCondition.js'
import ExpressionEvaluator from './expression/ExpressionEvaluator.js'
// import IncludesCondition from './IncludesCondition.js'
// import IncludesSatisfies from './IncludesEvaluator.js'

export default {
  install( plg ) {
    plg.addPlugin( 'Model', { type : LogicCondition.TYPE, model : LogicCondition } )
    plg.addPlugin( 'Condition', LogicCondition )
    plg.addPlugin( 'ConditionEvaluator', { type : LogicCondition.TYPE, evaluator : LogicEvaluator } )
    plg.addPlugin( 'AsyncConditionEvaluator', { type : LogicCondition.TYPE, evaluator : AsyncLogicEvaluator } )

    plg.addPlugin( 'Model', { type : PropertyCondition.TYPE, model : PropertyCondition } )
    plg.addPlugin( 'Condition', PropertyCondition )
    plg.addPlugin( 'ConditionEvaluator', { type : PropertyCondition.TYPE, evaluator : PropertyEvaluator } )

    plg.addPlugin( 'condition.ExpressionPreprocessor', TargetPreprocessor )
    plg.addPlugin( 'Model', { type : ExpressionCondition.TYPE, model : ExpressionCondition } )
    plg.addPlugin( 'Condition', ExpressionCondition )
    plg.addPlugin( 'ConditionEvaluator', { type : ExpressionCondition.TYPE, evaluator : ExpressionEvaluator } )

  }
}
